/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const delay = (ms: number) =>
  new Promise((resolve) => setTimeout(resolve, ms));
